import Divider from '@mui/material/Divider';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Card from '@mui/material/Card';
import {
  ANNOTATION_SOURCE_LOCATION,
  RELATION_OWNED_BY,
} from '@backstage/catalog-model';
import { getEntityRelations, useEntity } from '@backstage/plugin-catalog-react';

import { useCardClasses } from '../../hooks';
import { SupportChannels } from '../SupportChannels';
import { TeamMembersContact } from '../TeamMembersContact';

type Props = {
  variant?: 'gridItem' | 'fullHeight';
};

export const TeamContactsCard = ({ variant = 'gridItem' }: Props) => {
  const { entity } = useEntity();
  const { cardClass, cardContentClass } = useCardClasses(variant);

  const owners = getEntityRelations(entity, RELATION_OWNED_BY);

  const sourceLocation =
    entity.metadata.annotations?.[ANNOTATION_SOURCE_LOCATION];

  return (
    <Card className={cardClass}>
      {owners.length > 0 && (
        <CardHeader
          title="Support"
          subheader={
            <SupportChannels
              owner={owners[0]}
              sourceLocation={sourceLocation}
            />
          }
        />
      )}
      {owners.length > 0 && <Divider />}
      <CardContent className={cardContentClass}>
        <TeamMembersContact entity={entity} />
      </CardContent>
    </Card>
  );
};
